import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
  message = '';

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.message =
      this.route.snapshot.queryParamMap.get('message') ||'Do not open or switch to another workbook while add-in operations are running. Doing so may cause the current operation to fail.'
    // Close after 2 minutes
    setTimeout(() => {
      Office.context.ui.messageParent('close');
    }, 5000);
  }
  closeDialog() {
    Office.context.ui.messageParent('close');
  }
}
